export default "__VITE_ASSET__DCQ41nKF__"